import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import { AuthContext } from "../contexts/AuthContext";
import { ScreenContext } from "../contexts/ScreenContext";

import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";

const Weather = React.memo(() => {
  const { token } = useContext(AuthContext);
  const { isDesktop } = useContext(ScreenContext);

  const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8080/";

  const [weather, setWeather] = useState({
    location: {
      name: "",
      region: "",
    },
    current: {
      temp_f: "",
      humidity: "",
      wind_mph: "",
      condition: {
        text: "",
        icon: "",
      },
    },
  });

  useEffect(() => {
    let unmounted = false;
    let source = axios.CancelToken.source();

    axios
      .get(API_URL + "weather", {
        cancelToken: source.token,
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        if (!unmounted) {
          setWeather(response.data);
        }
      })
      .catch((error) => {
        console.error("Weather-46", error);
      });

    return () => {
      unmounted = true;
      source.cancel();
    };
  }, []);

  return (
    <React.Fragment>
      <Grid
        container
        direction="row"
        alignItems="flex-start"
        justifyContent="flex-start"
      >
        <Grid item xs={12}>
          <Typography
            align="right"
            variant="button"
            display="block"
          >{`${weather.location.name}, ${weather.location.region}`}</Typography>
          <Typography
            align="right"
            variant="h3"
          >{`${weather.current.temp_f} \xB0F`}</Typography>
        </Grid>

        <Grid item xs={12}>
          <Grid container spacing={0}>
            <Grid item style={{ flexGrow: 1, paddingTop: 1 }}>
              <Typography
                style={{ lineHeight: isDesktop ? 1.5 : null }}
                align="right"
                variant="overline"
                display="block"
              >{`${weather.current.condition.text}`}</Typography>
              {isDesktop ? (
                <Typography
                  style={{ lineHeight: 1.5 }}
                  align="right"
                  variant="overline"
                  display="block"
                >{`humidity: ${weather.current.humidity}% Wind: ${weather.current.wind_mph} mph`}</Typography>
              ) : null}
            </Grid>
            <Grid item>
              <img
                src={`${weather.current.condition.icon}`}
                height={isDesktop ? 35 : 28}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </React.Fragment>
  );
});

export default Weather;
